import React from "react";
import { TimePicker as AntdTimePicker } from "antd";
import moment from "moment";

const TimePicker = ({
	defaultValue,
	dispatch,
	name,
	format = "HH:mm",
	isNew,
	dataType,
	questionId,
	outputFormat = "HH:mm",
	...otherProps
}) => {
	//data is stored in ISO format, rendered in local format
	const dateValue = defaultValue ? moment(defaultValue, "HH:mm") : null;
	const renderDateValue = dateValue ? moment(dateValue, format) : null;
	const [answerAdded, answerEdited] = dispatch;
	const handleDispatch = (e, date) => {
		let data = {
			questionId: questionId,
			value: moment(date, format).format(outputFormat),
			id: name,
		};
		if (!isNew) answerEdited(data);
		else answerAdded(data);
	};
	return (
		<AntdTimePicker
			allowClear={false}
			showTime={dataType === "datetime"}
			format={format}
			defaultValue={renderDateValue}
			onChange={handleDispatch}
			name={name}
			{...otherProps}
			suffixIcon={null}
		/>
	);
};

export default TimePicker;
